export default function PageHeader({ title, subtitle, right }) {
    return (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
            <div>
                <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-[#0A0A0A]" data-testid="page-title">
                    {title}
                </h1>
                {subtitle && <p className="text-sm text-edu-body mt-1">{subtitle}</p>}
            </div>
            {right && <div className="flex items-center gap-3">{right}</div>}
        </div>
    );
}
